import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'comp-dealer-selector',
    templateUrl: './dealer-selector.component.html',
    styleUrls: ['./dealer-selector.component.scss'],
})
export class DealerSelectorComponent implements OnInit {
    // Conversation
    @Input() dealers: any = [];

    // Dealer
    dealer: any = {};

    constructor(
        private userService: UserService,
        private router: Router,
        private modalCtrl: ModalController
    ) {}

    ngOnInit(): void {
        // Dealer List
        this.dealers = this.userService.selectorDealers?.length
            ? this.userService.selectorDealers
            : this.userService.dealers;

        // Selected Dealer
        this.dealer = this.userService.dealer;
    }

    private clean(value: any): string {
        return String(value ?? '').trim();
    }

    displayName(store: any): string {
        const name = this.clean(store?.name);
        if (name) return name;

        const slug = this.clean(store?.tenant_slug);
        if (slug) return slug;

        const ref = this.clean(store?.dealer_reference);
        return ref ? `Dealer ${ref}` : 'Dealer';
    }

    displayAddress(store: any): string {
        const parts = [store?.address, store?.city, store?.province, store?.country]
            .map((v) => this.clean(v))
            .filter((v) => v.length > 0);
        return parts.join(', ');
    }

    /**
     * [onDealerClick - Sets the new dealers store]
     * @param   {store}
     * @returns {void}
     */
    onDealerClick(store): void {
        const rawUrl = String(store?.url || '').trim();
        const targetUrl = rawUrl && /^https?:\/\//i.test(rawUrl) ? rawUrl : (rawUrl ? `https://${rawUrl}` : '');
        if (targetUrl) {
            this.modalCtrl.dismiss();
            window.location.href = targetUrl;
            return;
        }

        // Check If Dealers Selected
        if(store.id == this.dealer.id) {
            return;
        }

        // Assign Store
        this.dealer = store;
        this.userService.dealer = store;

        // Update Dealer Viewing
        this.userService.setUserDealer(this.dealer)
            .subscribe((resp) => {
                this.modalCtrl.dismiss();
                this.router.navigate(['redirect'], { queryParams: { storeChange: store.id}});
            });
    }
}
